import React from 'react';

import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { TablaCalculos } from './TablaCalculos';

export const ModalDetalles = (props) => {

    const {datosTablaCalculos, verModal, cerrarVerModal} =props;

    const cerrarModal = () => {
        cerrarVerModal(false);
    }

    const pieDialogo = () => {
        return (
            <div>
                <Button label="Cerrar" icon="pi pi-times" onClick={cerrarModal} className="p-button-secondary"/>
            </div>
        );
    }

    return (<div>
        <Dialog header={"Detalles"} visible={verModal}
            style={{ width: '50vw' }} modal={true} onHide={cerrarModal} footer={pieDialogo()}>
            <TablaCalculos datos={datosTablaCalculos} />
        </Dialog>
    </div>);
}